export default __webpack_public_path__ + "static/media/Medical Device Innovation.72ea1d71.pdf";